import * as Yup from 'yup';

export const CLARAVIEW_LINK_ORIGIN = 'https://app.claraview.ai';

export const extractDynamicPart = (company) => {
    if (!company) return '';
    const match = company.match(/^claraview-(.+)$/);
    return match ? match[1] : '';
};

export const getClaraviewLink = (company) =>
    `${CLARAVIEW_LINK_ORIGIN}/${extractDynamicPart(company) || 'your-company'}`;

export const COMPANY_PREFIX = 'claraview-';
export const SLUG_MIN_LENGTH = 2;
export const SLUG_MAX_LENGTH = 40;

export const extractEditableSlug = (company) => {
    const value = (company || '').trim().toLowerCase();
    return value.startsWith(COMPANY_PREFIX) ? value.slice(COMPANY_PREFIX.length) : '';
};

// Messages mirror the backend's word-for-word — they're clinic-facing copy, and the
// backend deliberately never mentions the claraview- prefix, so neither do we.
export const companySlugSchema = Yup.string()
    .trim()
    .lowercase()
    .matches(/^[a-z0-9]+$/, {
        message: 'Your link can only contain letters and numbers - no spaces, dashes or other symbols.',
        excludeEmptyString: true,
    })
    .required('Please enter a link.')
    .min(SLUG_MIN_LENGTH, 'Your link must be at least 2 characters long.')
    .max(SLUG_MAX_LENGTH, 'Your link must be 40 characters or fewer.');

export const validateCompanySlug = (slug) => {
    try {
        companySlugSchema.validateSync(slug);
        return null;
    } catch (error) {
        return error.message;
    }
};

export const buildCompany = (slug) => `${COMPANY_PREFIX}${(slug || '').trim().toLowerCase()}`;
